import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IMissionState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const missionModule: Module<IMissionState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default missionModule
